function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String, isOpen) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const canClickRow = $attr(`enable-row-click`);
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'is-closed': !isOpen,
          inline: $attr(`theme`) === $helpers.CollapsibleTheme.INLINE,
        }, {
          'mp-collapsible': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: canClickRow ? $helpers.toggleOpen : null
          },
          "class": Object.assign({}, {
            'is-clickable': canClickRow,
          }, {
            'mp-collapsible-title-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($helpers.hasSlot($component, `title`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-collapsible-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  name: `title`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: !canClickRow ? $helpers.toggleOpen : null
              },
              "class": {
                'mp-collapsible-title': true,
                'is-clickable': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat($attr(`header-title`));
              __jade_nodes = __jade_nodes.concat(($attr(`tooltip-text`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", [__vjadeSafeCode($attr(`tooltip-text`))]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'icon': isOpen ? `caret-up` : `caret-down`,
              'theme': `tertiary`,
            }),
            "on": {
              click: !canClickRow ? $helpers.toggleOpen : null
            },
            "class": {
              'hidden': $attr(`hide-caret`),
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-collapsible-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("slot"));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "isOpen" in locals ? locals.isOpen : typeof isOpen !== "undefined" ? isOpen : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;